import {useNavigate} from "react-router-dom";
import {ArrowLeft} from "react-bootstrap-icons";
import React from "react";

import "./BackButton.css";

// Navigates to `to` when given (a stable parent page beats history when the
// current page mutates the URL, e.g. filter params); otherwise goes back one
// history entry.
export function BackButton({ to }) {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(to ?? -1);
    };

    return (
        <button className="btn btn-link back-button" onClick={handleBackClick} aria-label="Back">
            <ArrowLeft className="arrow-icon"/>
        </button>
    );
}